<div class="advancedFilter__row">
  <pp-advanced-filter-condition
    [ppLogic]="ppLogic"
    (ppLogicChange)="changeLogic($event)"
    [ppIndex]="ppIndex"
  ></pp-advanced-filter-condition>

  <pp-advanced-filter-field-select
    [(ppFilter)]="ppFilter"
    (ppFilterChange)="changeFilterType($event)"
    [ppWorkspaceId]="ppWorkspaceId"
  ></pp-advanced-filter-field-select>

  <!-- Filter types -->
  @switch (ppFilter.type) {
    @case (EAdvancedFilterType.PRIORITY) {
      <pp-advanced-filter-priority
        [ppIndex]="ppIndex"
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-priority>
    }
    @case (EAdvancedFilterType.TEXT) {
      <pp-advanced-filter-text
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-text>
    }
    @case (EAdvancedFilterType.TITLE) {
      <pp-advanced-filter-text
        [(ppFilter)]="ppFilter"
        [isTitleType]="true"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-text>
    }
    @case (EAdvancedFilterType.PERCENTAGE) {
      <pp-advanced-filter-percentage
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-percentage>
    }
    @case (EAdvancedFilterType.FORMULA) {
      <pp-advanced-filter-formula
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-formula>
    }
    <!-- Rich text and text use the same component -->
    @case (EAdvancedFilterType.RICH_TEXT) {
      <pp-advanced-filter-text
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-text>
    }
    @case (EAdvancedFilterType.SITE) {
      <pp-advanced-filter-site
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-site>
    }
    @case (EAdvancedFilterType.ACCOUNT) {
      <pp-advanced-filter-account
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-account>
    }
    @case (EAdvancedFilterType.ACCOUNT_SITE) {
      @if (isOverview || isTimeline) {
        <pp-advanced-filter-account-sites
          [(ppFilter)]="ppFilter"
          (ppFilterChange)="applyChanges()"
          data-test="advanced-filter-account-sites"
        ></pp-advanced-filter-account-sites>
      }
    }

    @case (EAdvancedFilterType.CHECKBOX) {
      <pp-advanced-filter-checkbox
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-checkbox>
    }
    @case (EAdvancedFilterType.DURATION) {
      <pp-advanced-filter-duration
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-duration>
    }
    @case (EAdvancedFilterType.TAG) {
      <pp-advanced-filter-tag
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
        [ppWorkspaceId]="ppWorkspaceId"
      ></pp-advanced-filter-tag>
    }
    @case (EAdvancedFilterType.STATUS) {
      <pp-advanced-filter-status
        [ppIndex]="ppIndex"
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-status>
    }
    @case (EAdvancedFilterType.DATE) {
      <pp-advanced-filter-date
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
        ppType="date"
      ></pp-advanced-filter-date>
    }
    @case (EAdvancedFilterType.DATE_CREATED) {
      <pp-advanced-filter-date
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
        ppType="date_created"
      ></pp-advanced-filter-date>
    }
    @case (EAdvancedFilterType.DATE_UPDATED) {
      <pp-advanced-filter-date
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
        ppType="date_updated"
      ></pp-advanced-filter-date>
    }
    @case (EAdvancedFilterType.REMINDER) {
      <pp-advanced-filter-date
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
        ppType="date"
      ></pp-advanced-filter-date>
    }
    @case (EAdvancedFilterType.REMINDER_TYPE) {
      <pp-advanced-filter-reminder-type
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-reminder-type>
    }
    @case (EAdvancedFilterType.REMINDER_STATE) {
      <pp-advanced-filter-reminder-state
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-reminder-state>
    }
    @case (EAdvancedFilterType.REMINDER_CREATED_BY) {
      <pp-advanced-filter-reminder-created-by
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-reminder-created-by>
    }
    @case (EAdvancedFilterType.FLAGGED) {
      <pp-advanced-filter-flag
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-flag>
    }
    @case (EAdvancedFilterType.TIMELINE) {
      <pp-advanced-filter-timeline
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-timeline>
    }
    @case (EAdvancedFilterType.CREATED_BY) {
      <pp-advanced-filter-users
        [ppIndex]="ppIndex"
        [(ppFilter)]="ppFilter"
        ppType="created_by"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-users>
    }
    @case (EAdvancedFilterType.ASSIGNEE) {
      <pp-advanced-filter-users
        [ppIndex]="ppIndex"
        ppType="assignees"
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-users>
    }
    @case (EAdvancedFilterType.NUMBER) {
      <pp-advanced-filter-number
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
        ppType="number"
      ></pp-advanced-filter-number>
    }
    @case (EAdvancedFilterType.SEQUENCE_NUMBER) {
      <pp-advanced-filter-number
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
        ppType="sequence_number"
      ></pp-advanced-filter-number>
    }
    @case (EAdvancedFilterType.COST) {
      <pp-advanced-filter-number
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
        ppType="cost"
      ></pp-advanced-filter-number>
    }
    @case (EAdvancedFilterType.LIST) {
      <pp-advanced-filter-list
        [(ppFilter)]="ppFilter"
        data-test="advanced-filter-list"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-list>
    }
    @case (EAdvancedFilterType.MULTI_LIST) {
      <pp-advanced-filter-multi-list
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-multi-list>
    }
    @case (EAdvancedFilterType.LOCATION) {
      <pp-advanced-filter-location
        [(ppFilter)]="ppFilter"
        (ppFilterChange)="applyChanges()"
      ></pp-advanced-filter-location>
    }
  }

  <!-- End of filter types -->

  <button
    class="advancedFilter__delete-button"
    (click)="deleteFilter()"
    (mouseenter)="buttonHover(true)"
    (mouseleave)="buttonHover(false)"
  >
    <pp-icon
      [ppSrc]="EIconPath.ICON_CLOSE_18"
      [ppColor]="buttonHovered ? 'grey-600' : 'grey-400'"
      ppClass="setSize18"
    ></pp-icon>
  </button>
</div>
